import run from'../../utilities/run';
import $ from'jquery';
import _ from"underscore";
import {setElementsFromScope} from"./../../utilities/selectorHelpers";

const targetSelector="#received-order-form";

run(targetSelector, (mainEl) => {
attachOrgForm(mainEl);
});

function attachOrgForm(mainEl) {
const facilityData=mainEl.data("facility-data");
const viewUrl=mainEl.data("facility-url"); 
const viewOrderRenderUrl=mainEl.data("view-order-render-url");

const els= {};
const elementsMap= {
addFacilitySelect :'#facility-select',
}

function init() {
setElements();
bindElements();
renderFacilityList();
} 

function setElements() {
setElementsFromScope(els, elementsMap, mainEl);
}

function bindElements(){ 
els.addFacilitySelect.on('change', facilityChangeRequest); 
}

function renderFacilityList(){
  $(facilityData).each(function(){
    var option=$('<option />');
    option.attr('value', this.facId).text(this.facName);
    els.addFacilitySelect.append(option);
  });
}

function facilityChangeRequest(){
   let facId = els.addFacilitySelect.val();
   let newviewUrl=`${viewUrl}&facId=${facId}`;
   $.ajax({
      url: newviewUrl,
      type: 'POST',
      dataType: "JSON",
      data:  {
        facId:facId
      },
      success:function(response) {
        $('#yesterdayorders').html(response.yesterday);
        $('#sevendays').html(response.last7days);
        $('#forteendays').html(response.last14days);
        $('#yesterdayorderLink').attr('href',viewOrderRenderUrl+"&filterFlag=yesterday&facId="+facId);
        $('#sevendaysorderLink').attr('href',viewOrderRenderUrl+"&filterFlag=sevendays&facId="+facId);
        $('#forteendaysorderLink').attr('href',viewOrderRenderUrl+"&filterFlag=fourteendays&facId="+facId);

      },
      error: function(response){
          console.log("error"+JSON.stringify(response));
      }
    }); 
}

init();
}




// WEBPACK FOOTER //
// ./src/pages/dashboard/received-order.js